import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M17.192 1.762C11.944-.056 6.563 3.173 4.636 7.827q-.316-.537-.594-1.114a1.234 1.234 0 0 0-2.278.128c-1.83 5.238 1.433 10.584 6.089 12.486q-.562.333-1.171.622a1.239 1.239 0 0 0 .126 2.289c5.218 1.808 10.563-1.376 12.519-5.975.255.34.467.684.631 1.024a1.234 1.234 0 0 0 2.278-.128c1.819-5.204-1.393-10.513-5.992-12.446.356-.27.717-.491 1.074-.662a1.239 1.239 0 0 0-.126-2.289M16.107 3c-4.645-1.206-9.43 2.163-10.5 6.68a.75.75 0 0 1-1.316.293 13 13 0 0 1-1.3-2.013c-1.184 4.611 2.203 9.345 6.716 10.389a.75.75 0 0 1 .298 1.317c-.641.511-1.35.954-2.086 1.341 4.537 1.162 9.2-2.035 10.4-6.398a.75.75 0 0 1 1.249-.336 9 9 0 0 1 1.434 1.794c1.178-4.517-2.037-9.157-6.411-10.34a.75.75 0 0 1-.34-1.25A9.2 9.2 0 0 1 16.107 3"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M12.016 8.616c-1.873 0-3.38 1.528-3.38 3.4 0 1.873 1.507 3.4 3.38 3.4s3.38-1.527 3.38-3.4-1.508-3.4-3.38-3.4m0 1.5a1.89 1.89 0 0 0-1.88 1.9c0 1.055.846 1.9 1.88 1.9a1.89 1.89 0 0 0 1.88-1.9 1.89 1.89 0 0 0-1.88-1.9"
      clipRule="evenodd"
    />
  </>
);

const Weather2 = Icon('weather-2', svgContents);

export default Weather2;
